import cn from 'classnames';
import { useRouter } from 'next/router';
import { useMemo } from 'react';

import { FilterTrigger } from '../consts';
import { FilterButtonProps } from '../types';
import styles from './FilterButton.module.scss';

const FilterButton = ({ buttonText, isSticky, available = true }: FilterButtonProps) => {
    const { query, replace } = useRouter();

    const filterLetter = useMemo(() => query.filter as string, [query.filter]);
    const isActive = filterLetter === buttonText;
    const FilterTriggers = useMemo(() => Object.values(FilterTrigger), []);
    const isTriggerButton = FilterTriggers.some(el => buttonText === el);

    const filterChange = (letter: string) => {
        replace(`?filter=${letter}`, undefined, { shallow: true });
    };

    return (
        <button
            type="button"
            data-testid="button-filter"
            disabled={!available}
            className={cn(
                styles.button,
                isActive && styles.button_active,
                isSticky && styles.button_sticky,
                !isTriggerButton && styles.button_letter
            )}
            onClick={() => filterChange(buttonText)}
        >
            {buttonText}
        </button>
    );
};

export default FilterButton;
